// extracted by mini-css-extract-plugin
export default {"container":"LandingPage_container__OaEk9","main":"LandingPage_main__I-Dk-"};